import { type ReactNode } from "react";

function PageMain({ children }: { children: ReactNode }) {
  return <main className="py-6 sm:px-6 lg:px-8">{children}</main>;
}

export default PageMain;
